import mainEn from './en/en.json'
import mainAr from './ar/ar.json'
import mainEs from './es/es.json'
import mainDe from './de/de.json'
import mainIt from './it/it.json'
import mainFr from './fr/fr.json'
import mainPt from './pt/pt.json'
import mainEl from './el/el.json'
import mainBn from './bn/bn.json'
import mainSr from './sr/sr.json'
import mainCs from './cs/cs.json'
import mainPl from './pl/pl.json'
import mainHu from './hu/hu.json'
import mainSk from './sk/sk.json'
import mainRo from './ro/ro.json'
import mainBg from './bg/bg.json'
import mainMk from './mk/mk.json'
import mainSq from './sq/sq.json'

const MainMessages = {
  en: mainEn,
  ar: mainAr,
  es: mainEs,
  de: mainDe,
  it: mainIt,
  fr: mainFr,
  pt: mainPt,
  el: mainEl,
  bn: mainBn,
  sr: mainSr,
  cs: mainCs,
  pl: mainPl,
  hu: mainHu,
  sk: mainSk,
  ro: mainRo,
  bg: mainBg,
  mk: mainMk,
  sq: mainSq,
}

export default MainMessages
